/**
 * YYYY年MM月DD日(eee) HH:MM
 */
export const PUBLISH_DATETIME_LABEL_FORMAT = 'llll'

/**
 * YYYY年MM月DD日(eee)
 */
export const PUBLISH_DATE_LABEL_FORMAT = 'LL(ddd)'
